<template>
  <form novalidate @submit.prevent="addProperty">
    <LsModal title="Add a Property" track-id="add_property_modal">
      <template #body>
        <LsGoogleAutocomplete
          ref="autocomplete"
          @placechanged="placeChanged"
          @focus="clearAddress"
        />
      </template>
      <template #footer
        ><LsButton
          :disabled="!street && !city && !state && !zip"
          text="add property"
          track-id="add_property_modal-add_property"
          type="submit"
          :loading="properties.loadingStatus.isUpdating"
      /></template>
    </LsModal>
  </form>
</template>

<script>
import { LsModal, LsButton, LsGoogleAutocomplete } from '@/components/common';
import { mapActions, mapState } from 'vuex';
import { PROPERTIES__ADD_PROPERTY } from '@/store/types';

export default {
  name: 'AddPropertyModal',
  components: {
    LsModal,
    LsButton,
    LsGoogleAutocomplete,
  },
  data() {
    return {
      street: '',
      city: '',
      state: '',
      zip: '',
    };
  },
  computed: {
    ...mapState(['properties']),
  },
  mounted() {
    this.$refs.autocomplete.focus();
  },
  methods: {
    ...mapActions([PROPERTIES__ADD_PROPERTY]),
    addProperty() {
      this[PROPERTIES__ADD_PROPERTY]({
        street: this.street,
        city: this.city,
        state: this.state,
        zip: this.zip,
        onSuccess: this.$parent.close,
      });
    },
    placeChanged({ street, city, state, zip }) {
      this.street = street;
      this.city = city;
      this.state = state;
      this.zip = zip;
    },
    clearAddress() {
      this.$refs.autocomplete.clear();
      this.street = '';
      this.city = '';
      this.state = '';
      this.zip = '';
    },
  },
};
</script>

<style lang="scss"></style>
